module.exports = __webpack_public_path__ + "img/google_analytics_help_connexion.0b4138b2.png";